import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo, MenuIcon, CloseIcon } from "../assets";
import { useStateContext } from "../context/StateContextAPI";
import "./navbar.component.css";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const NavbarComponent = () => {
    const navigate = useNavigate();
    const [menuIconActive, setMenuIconActive] = useState(false);
    const { activePage } = useStateContext();
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const handleClick = (url: string) => {
        navigate(`${url}`);
        setMenuIconActive(false);
    };

    const toggleMenu = () => {
        setMenuIconActive(!menuIconActive);
    };

    return (
        <div className="navbar-container">
            <div className="nav-logo">
                <img src={Logo} onClick={() => handleClick("/")} alt="rokk_app_logo" />
            </div>
            <div className="nav-links">
                <li
                    onClick={() => handleClick("/")}
                    id={`${activePage === "home" ? "activeLink" : ""}`}
                >
                    {t('nav.home')}
                </li>
                <li onClick={() => handleClick("/rokk")}
                    id={`${activePage === "rokk" ? "activeLink" : ""}`}>{t('nav.rokkApp')}</li>
                <li onClick={() => handleClick("/fairness")}
                    id={`${activePage === "fairness" ? "activeLink" : ""}`}>{t('nav.fairness')}</li>
                <li onClick={() => handleClick("/about-us")}
                    id={`${activePage === "about" ? "activeLink" : ""}`}>{t('nav.aboutUs')}</li>
                <li onClick={() => handleClick("/faq")}
                    id={`${activePage === "faq" ? "activeLink" : ""}`}>{t('nav.faq')}</li>
                <li onClick={() => handleClick("/artist")}
                    id={`${activePage === "artists" ? "activeLink" : ""}`}>{t('nav.forArtists')}</li>
            </div>
            <div className="auth-section-nav-bar">
                <div className="language-picker">
                    <span
                        className={`lang-option ${i18n.language === 'en' ? 'lang-active' : ''}`}
                        onClick={() => changeLanguage('en')}
                    >
                        EN
                    </span>
                    <span className="lang-separator">|</span>
                    <span
                        className={`lang-option ${i18n.language === 'de' ? 'lang-active' : ''}`}
                        onClick={() => changeLanguage('de')}
                    >
                        DE
                    </span>
                </div>
                <Button
                    variant="contained"
                    sx={{
                        background: '#ff8303',
                        color: '#ffffff',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        '&:hover': {
                            background: '#ff8303'
                        }
                    }}
                    onClick={() => handleClick("/login")}
                >
                    {t('nav.login')}
                </Button>
            </div>

            <div className="navbar-mobile-actions">
                <div className="language-picker language-picker-mobile-nav">
                    <span
                        className={`lang-option ${i18n.language === 'en' ? 'lang-active' : ''}`}
                        onClick={() => changeLanguage('en')}
                    >
                        EN
                    </span>
                    <span className="lang-separator">|</span>
                    <span
                        className={`lang-option ${i18n.language === 'de' ? 'lang-active' : ''}`}
                        onClick={() => changeLanguage('de')}
                    >
                        DE
                    </span>
                </div>
                <div className="menu-icon" onClick={toggleMenu}>
                    {menuIconActive ? (
                        <img src={CloseIcon} alt="close_icon" />
                    ) : (
                        <img src={MenuIcon} alt="menu_icon" />
                    )}
                </div>
                
            </div>
            {menuIconActive && (
                <div className="sidebar-container">
                    <div className="menu-icon" onClick={toggleMenu}>
                        {menuIconActive ? (
                            <>
                                <img src={CloseIcon} alt="close_icon" />
                                {t('nav.close')}</>
                        ) : (
                            <img src={MenuIcon} alt="menu_icon" />
                        )}
                    </div>
                    <div className="sidebar-links">
                        <li
                            onClick={() => handleClick("/")}
                            id={`${activePage === "home" ? "activeLink" : ""}`}
                        >
                            {t('nav.home')}
                        </li>
                        <li onClick={() => handleClick("/rokk")}
                            id={`${activePage === "rokk" ? "activeLink" : ""}`}>{t('nav.rokkApp')}</li>
                        <li onClick={() => handleClick("/fairness")}
                            id={`${activePage === "fairness" ? "activeLink" : ""}`}>{t('nav.fairness')}</li>
                        <li onClick={() => handleClick("/about-us")}
                            id={`${activePage === "about" ? "activeLink" : ""}`}>{t('nav.aboutUs')}</li>
                        <li onClick={() => handleClick("/faq")}
                            id={`${activePage === "faq" ? "activeLink" : ""}`}>{t('nav.faq')}</li>
                        <li onClick={() => handleClick("/artist")}
                            id={`${activePage === "artists" ? "activeLink" : ""}`}>{t('nav.forArtists')}</li>

                        <Button
                            variant="contained"
                            sx={{
                                background: '#ff8303',
                                color: '#ffffff',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                borderRadius: '8px',
                                '&:hover': {
                                    background: '#ff8303'
                                }
                            }}
                            onClick={() => handleClick("/login")}
                        >
                            {t('nav.login')}
                        </Button>

                        <div className="language-picker language-picker-mobile">
                            <span
                                className={`lang-option ${i18n.language === 'en' ? 'lang-active' : ''}`}
                                onClick={() => changeLanguage('en')}
                            >
                                EN
                            </span>
                            <span className="lang-separator">|</span>
                            <span
                                className={`lang-option ${i18n.language === 'de' ? 'lang-active' : ''}`}
                                onClick={() => changeLanguage('de')}
                            >
                                DE
                            </span>
                        </div>
                    </div>

                </div>
            )}
        </div>
    );
};

export default NavbarComponent;
